module.exports = __webpack_public_path__ + "static/media/defaultNetworkImage.b5cd04d1.svg";